export default __webpack_public_path__ + "static/media/M07.59c38a9d.svg";